import React from 'react'
import { Query } from 'react-apollo'
import _ from 'lodash'
import { Tooltip } from 'antd'
import { Icon, Div, Loading } from 'konsys-ui'
import { ChevronsUpDown } from 'lucide-react'
import { TRUCK_TYPE, GET_FLEETS } from '../../../constants/graphql/query'
import {
  InputWithPlaceHolder, StatusSelector, ActionSelector, HeaderLabel, CellText, DropdownSelector, StatusCell,
} from '../../../components/trailer-components'
import { theme } from '../../../styles/_variables'
import { status, statusText } from '../constants'
import { colorSelector } from '../detail/component-renderer'

const { color } = theme

export default {
  columns: [{
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ทะเบียนหาง <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'trailerPlate',
    sortable: true,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.trailerPlate, filter.value),
    width: 150,
  }, {
    Header: <HeaderLabel>ทะเบียนหัว</HeaderLabel>,
    accessor: 'truck.plateNumber',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.t, filter.value),
    width: 150,
  }, {
    Header: <HeaderLabel>ชนิดหาง</HeaderLabel>,
    accessor: 'type.nameTh',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <Query
      query={TRUCK_TYPE} // change
    >
     { ({ error, loading, data }) => {
       if (error) return <p>เกิดข้อผิดพลาด</p>
       if (loading && _.isEmpty(data)) return <Loading center='true' />
       let newArr = [{ value: 'ALL', text: 'ทั้งหมด' }]
       newArr = _.concat(newArr, data.TruckTypes.lists.map(v => (
         { value: v.nameTh, text: v.nameTh } // change
       )))
       return (
          <DropdownSelector
            key='filter'
            data={newArr}
            handleChange={e => onChange(e)}
            filter={true}
            statusAttr='ทั้งหมด'
            typeNameTh={true}
          />
       )
     }}
    </Query>,
    filterMethod: (filter, row) => _.includes(row.t, filter.value),
    width: 140,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เลขคัตซี <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'chassisNumber',
    sortable: true,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.trailerPlate, filter.value),
    width: 150,
  }, {
    Header: <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={statusText[props.value]}><CellText color={colorSelector(props.value)}>{statusText[props.value]}</CellText></Tooltip>,
    Filter: ({ onChange }) => (
      <DropdownSelector
        key='filter'
        data={[
          { value: undefined, text: 'ทั้งหมด' },
          { value: status.AVAILABLE, text: statusText.AVAILABLE },
          { value: status.IN_USE, text: statusText.IN_USE },
          { value: status.REPAIRING, text: statusText.REPAIRING },
          { value: status.OUT_OF_SERVICE, text: statusText.OUT_OF_SERVICE },
          { value: status.WATCHING, text: statusText.WATCHING },
        ]}
        handleChange={e => onChange(e)}
        filter={true}
        statusAttr='ทั้งหมด'
        typeNameTh={true}
      />
    ),
    filterMethod: (filter, row) => _.includes(row.t, filter.value),
    width: 140,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
